import { type ReactElement, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import {
  TipContainer,
  TipIcon,
  TipTextContainer,
} from '@/components/srp/zero-results/SearchTip/styled'
import { BodyText } from '@/ui/atoms/body-text'
import { TextLink } from '@/ui/atoms/text-link'

export type SearchTipProps = {
  icon: ReactElement | null
  text: string
  actionText?: string
  handleClick?: () => void
}

export const SearchTip = ({ icon, text, actionText, handleClick }: SearchTipProps) => {
  const theme = useContext(ThemeContext)

  return (
    <TipContainer>
      <TipIcon>{icon}</TipIcon>
      <TipTextContainer>
        <BodyText color={theme.colors.grey.primary}>{text}</BodyText>
        {actionText && (
          <TextLink as="button" variant="secondary" onClick={handleClick}>
            {actionText}
          </TextLink>
        )}
      </TipTextContainer>
    </TipContainer>
  )
}
